import React from "react";
import {
  Box,
  Grid,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  FormGroup,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const handleChangeFirstLineAsColumnNameSwitch = (val) => {
  if (val !== undefined) {
    val =
      localStorage.getItem("CSVFirstLineAsColumnName") === "false"
        ? true
        : false;
    localStorage.setItem("CSVFirstLineAsColumnName", val);
  }
};

const handleChangeRemoveQuotesSwitch = (val) => {
  if (val !== undefined) {
    val = localStorage.getItem("CSVRemoveQuotes") === "false" ? true : false;
    localStorage.setItem("CSVRemoveQuotes", val);
  }
};

const handleChangeSeparator = (val) => {
  localStorage.setItem("CSVSeparator", val);
};

export default function LoadFIleView(props) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Grid
        container
        sx={{
          top: 0,
          bottom: 0,
          marginTop: "12%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item xs={3}>
          <FormGroup>
            <Box mt={2}>
              <FormControlLabel
                onClick={(e) =>
                  handleChangeFirstLineAsColumnNameSwitch(e.target.value)
                }
                control={
                  <Switch
                    defaultChecked={
                      localStorage.getItem("CSVFirstLineAsColumnName") ===
                      "true"
                        ? true
                        : false
                    }
                  />
                }
                label="Primeira linha como descrição" /* trad */
                defaultChecked={
                  localStorage.getItem("CSVFirstLineAsColumnName") === "true"
                    ? true
                    : false
                }
                value={
                  localStorage.getItem("CSVFirstLineAsColumnName") === "true"
                    ? true
                    : false
                }
              />
            </Box>
            <Box mt={2}>
              <FormControlLabel
                onClick={(e) => handleChangeRemoveQuotesSwitch(e.target.value)}
                control={
                  <Switch
                    defaultChecked={
                      localStorage.getItem("CSVRemoveQuotes") === "true"
                        ? true
                        : false
                    }
                  />
                }
                label="Remover &#34;aspas&#34; das extremidades" /* trad */
                defaultChecked={
                  localStorage.getItem("CSVRemoveQuotes") === "true"
                    ? true
                    : false
                }
                value={
                  localStorage.getItem("CSVRemoveQuotes") === "true"
                    ? true
                    : false
                }
              />
            </Box>
            <Box mt={2}>
              <TextField
                label="Separador" /* trad */
                variant="outlined"
                defaultValue={localStorage.getItem("CSVSeparator")}
                sx={{ width: "120px" }}
                onChange={(e) => handleChangeSeparator(e.target.value)}
              />
            </Box>
            <Box mt={2}>
              <Button
                variant="contained"
                component="label"
                endIcon={<UploadIcon />}
              >
                Carregar Arquivo CSV{/* trad */}
                <input
                  id="file"
                  type="file"
                  hidden
                  onChange={(e) => props.handleUploadFile(e)}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
              </Button>
            </Box>
          </FormGroup>
        </Grid>
      </Grid>
    </Box>
  );
}
